// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { PurchaseOrderLineItem } from './purchase-order-line-item';
import { VendorPaymentMethod } from './vendor-payment-method';
import { VendorTerm } from './vendor-term';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Vendor extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  get displayAddress() {
    const line1 = _([this.address1, this.address2, this.address3, this.city]).filter(s => !!s).valueOf();
    if (line1.length > 0) line1[line1.length - 1] += ',';
    const line2 = _([this.state, this.postalCode, this.country]).filter(s => !!s).valueOf();
    return [...line1, ...line2].join(' ');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  accountNumber?: string;
  address1?: string;
  address2?: string;
  address3?: string;
  city?: string;
  companyName?: string;
  contactName?: string;
  country?: string;
  defaultLineItemId?: number;
  deleted?: Date;
  email?: string;
  fax?: string;
  inactive?: Date;
  internalNotes?: string;
  notes?: string;
  paymentMethodId?: number;
  phone?: string;
  postalCode?: string;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  quickBooksLastImport?: Date;
  quickBooksOnlineId?: string;
  quickBooksOnlineLastExport?: Date;
  remitAddress1?: string;
  remitAddress2?: string;
  remitAddress3?: string;
  remitCity?: string;
  remitEmail?: string;
  remitPhone?: string;
  remitPostalCode?: string;
  remitState?: string;
  state?: string;
  termsId?: number;
  defaultLineItem!: PurchaseOrderLineItem;
  paymentMethod!: VendorPaymentMethod;
  terms!: VendorTerm;
}

